import { withZod } from '@remix-validated-form/with-zod'
import { z } from 'zod'

const profileSchema = z.object({
  id: z.string(),
  name: z.string().min(1, 'Name is required'),
  email: z.string().email('Valid email is required'),
  phone: z.string().optional(),
})

export const profileValidator = withZod(profileSchema)
